module.exports = __webpack_public_path__ + "static/media/parent-and-child-with-physician.5887c8db.jpg";